import { PlatformDependent } from '@/components/PlatformDependent'
import { TitleSetter } from '@/components/Title'

import { UsersViewDDE } from './UsersView.dde'
import { UsersViewDGE } from './UsersView.dge'

export const UserAdminUsersView = () => (
  <>
    <TitleSetter title="Users" />

    <PlatformDependent dde>
      <UsersViewDDE />
    </PlatformDependent>

    <PlatformDependent streaming>
      <UsersViewDGE />
    </PlatformDependent>
  </>
)
